import React, {Component} from 'react'
import {NavLink} from 'react-router-dom'
import DatePicker from 'react-datepicker'
import * as moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import {UserNav, Event, Load} from './../../../components'
import Router from './../../../services/Router'
import { fetchPage } from '../../../services/ApiController'
import { ButtonRouter, AgendaStyle, DatePickerStyle } from './../../../styles'

const Week = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

export default class Agenda extends Component {

  state = {
    upcomming: [],
    lastEvent: [],
    now: new Date(),
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
    highlight: [],
    startDate: false,
    selectDay: null,
    ready: false,
  }

  componentDidMount() {
    this.getEvent()
  }

  componentWillMount () {
    clearTimeout(this.timer)
  }
  
  getEvent = async () => {
    const type = this.props.location.pathname.split('/')
    const { month, year } = this.state
    this.setState({ ready: false })
    await fetchPage(`/${type[type.length - 1]}/${year}/${month + 1 < 10 ? `0${month +1}` : month + 1 }`).then((data) => {
     this.setEventTime(data)
    }).catch((e) => {
      console.log('Oups something wrong with',`${type[type.length - 1]}/${year}/${month}`, e )
    })
  }

  setEventTime = (data) => {
    const lastEvent = []
    const upcomming = []
    const highlight = []
    
    data.map((event) => {
      const end = moment(event.date_end)
      const start = moment(event.date_start)
      const max = moment().daysInMonth()
      if (end.diff(moment(), 'days') >= 0) upcomming.push(event)   
      else lastEvent.push(event)
      if (end !== start) {
        const nb = end.diff(start, 'days')
        highlight.push(start.format())
        for (let i = 0; i < nb; i++) {
          const nDate = start.add(1, 'days')
          highlight.push(nDate.format())
        }
      } else {
        highlight.push(moment(event.date_start).format())
      }
    })
    lastEvent.sort((a, b) => moment(a.date).diff(moment(b.date)))
    upcomming.sort((a, b) => moment(a.date).diff(moment(b.date)))
    this.setState({ 
      lastEvent, 
      upcomming, 
      highlight: [{  "react-datepicker__day--highlighted": highlight }], 
      ready: true,
    })
  }

  handleChange = (date) => {
    this.setState({ 
      startDate : date, 
      // selectDay: date._d.getDate(), 
    })
  }

  handleClick = (date) => {
    this.setState({
      ready: false,
    }, () => {
      this.timer = setTimeout(() => {
        this.setState({ 
          ready: true,
          selectDay: (this.state.selectDay && moment(date._d).format() !== this.state.selectDay.format()) || !this.state.selectDay ? moment(date._d) : null,
        }, () => {
          if (!this.state.selectDay) document.querySelector('.react-datepicker__day--selected').classList.remove('react-datepicker__day--selected')
        })
      }, 400)
    })
  }

  handlerMonth = (date) => {
    this.setState({
      month: date._d.getMonth(),
      year: date._d.getFullYear(),
      ready: false
    }, () => {
      this.getEvent()
    })
  }
  
  render () {
    const { upcomming, lastEvent, startDate, highlight, selectDay, ready } = this.state
    return (
      <div className={` ${AgendaStyle(ready)}`}>
        <UserNav  />
        <div className="fluid">
          <div className="agenda-nav">
            <ul className={`reset ${ButtonRouter} flex`}>
              <li>
                <NavLink to={Router.event.path} exact> <span>Event</span> </NavLink>
              </li>
              {/* <li>
                <NavLink to={Router.tradeshow.path} exact> <span>Tradeshow</span> </NavLink>
              </li> */}
            </ul>

          </div>

          <div className="agenda-container">
              
            <div className={`agenda-datepicker ${DatePickerStyle} `}>
              <DatePicker
                inline
                selected={ startDate }
                onChange={ this.handleChange }
                onSelect={ this.handleClick }
                highlightDates={highlight}
                placeholderText="Date"
                onMonthChange={ this.handlerMonth }
              />
            </div>
            <div className="agenda-load">
              <Load width={24} height={24} />
            </div>
            <div className="agenda-transition">
            {
              upcomming.length > 0 && (
                <div className="agenda-upcomming">
                  {
                    !selectDay && (
                      <div className="agenda-title">
                        Upcoming event
                      </div>
                    )
                  }
                 
                  <div className="agenda-upcomming-event">
                    {
                      upcomming.filter(event => (
                        selectDay && moment(event.date_end).diff(selectDay, 'days') >= 0 && moment(event.date_start).diff(selectDay, 'days') <= 0
                      ) || !selectDay)
                        .map((event, index) => (
                          <Event {...event} key={index} />
                      ))
                    }
                  </div>
                </div>
              )
            }
            
            {
              lastEvent
                .filter(event => (
                  selectDay && moment(event.date_end).diff(selectDay, 'days') >= 0 && moment(event.date_start).diff(selectDay, 'days') <= 0
                ) || !selectDay).length > 0 && (
                <div className="agenda-past">
                  <div className="agenda-title">
                    Past event
                  </div>
                  <div className="agenda-past-event">
                    {
                      lastEvent
                          .filter(event => (
                            selectDay && moment(event.date_end).diff(selectDay, 'days') >= 0 && moment(event.date_start).diff(selectDay, 'days') <= 0
                          ) || !selectDay ) 
                        .map((event, index) => (
                        <Event {...event} key={index} />
                      ))
                    }
                  </div>
                </div>
              )
            }
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Agenda.js